import { Injectable, Injector, inject } from '@angular/core';
import { AuthClass } from '@aws-amplify/auth/lib-esm/Auth';
import { AuthState, authDecorator } from '@zero/shared/util-services';
import { CognitoUserPool, ICognitoUserPoolData } from 'amazon-cognito-identity-js';
import { Auth } from 'aws-amplify';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { WindowService } from '../dom/window.service';
import { ZeroStorage } from './zero-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CustomAmplifyService {
  readonly #auth: AuthClass;
  #authState = new Subject<AuthState>();
  public authStateChange$ = this.#authState.asObservable();
  #zeroStorage: ZeroStorage;

  readonly #injector = inject(Injector);
  readonly #windowService = inject(WindowService);

  constructor() {
    this.#auth = Auth;
    authDecorator(this.#authState, this.#auth);
  }

  public configure(): void {
    this.#zeroStorage = new ZeroStorage(this.#injector);
    this.#auth.configure({
      storage: this.#zeroStorage,
    });

    const cognitoEndpoint = environment.cognitoEndpointHost || this.#windowService.getDocumentOrigin();
    if (cognitoEndpoint && environment.cognitoEndpointPath) {
      const authEndpoint = cognitoEndpoint + environment.cognitoEndpointPath;
      const userPoolData: ICognitoUserPoolData = {
        UserPoolId: environment.amplifyconfig.Auth.userPoolId,
        ClientId: environment.amplifyconfig.Auth.userPoolWebClientId,
        endpoint: authEndpoint,
        Storage: this.#zeroStorage,
      };
      (this.#auth as any).userPool = new CognitoUserPool(userPoolData);
    }
  }

  public auth(): AuthClass {
    return this.#auth;
  }

  public authState(): Subject<AuthState> {
    return this.#authState;
  }

  public setAuthState(state: AuthState): void {
    this.#authState.next(state);
  }

  public getStorage(): ZeroStorage {
    return this.#zeroStorage;
  }
}
